import { render, staticRenderFns } from "./openZoneList.vue?vue&type=template&id=92506c1e&scoped=true"
import script from "./openZoneList.vue?vue&type=script&lang=js"
export * from "./openZoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92506c1e",
  null
  
)

export default component.exports